interface XiHeTaskProgress {
  status: number;
  generate_record_task_id: number;
  project_id: number;
  not_started_pending_task_count: number;
  not_started_wait_time: number;
  date_init_estimated_time: number;
  xihe_pending_task_count: number;
  xihe_queue_wait_time: number;
  xihe_remaining_time: number;
  xihe_estimated_time: number;
  xihe_running_time: number;
  xihe_percentage: number;
  xihe_start_time: string;
  xihe_finish_time: string;
  xihe_run_time: number;
  actual_running_time: number;
  estimate_need_coin: number;
  run_coin: number;
  speed_icon: number;
  is_speed: number;
}

export enum IBannedStatus {
  NORMAL = 0, // 未封禁
  BANNED = 1, // 封禁中
}

export enum IAppealStatus {
  // - 0: 初始状态
  NORMAL = 0,
  // - 1: 申诉中
  APPEALING = 1,
  // - 2: 申诉成功
  APPEAL_SUCCESS = 2,
  // - 3: 申诉失败
  APPEAL_FAIL = 3,
}

export interface ChengPianDetail {
  id: number;
  name: string;
  generated_record_id: number;
  task_id: string;
  project_id: number;
  user_id: number;
  video_url: string;
  project_resolution: string;
  status: number;
  cover_oss_path: string;
  file_format: number;
  cover_url: string;
  output_resolution: string;
  is_speed: number;
  with_subtitle: boolean;
  max_bitrate: number;
  remove_recent_record: boolean;
  frame: number;
  is_deleted: boolean;
  secret_id: string;
  project_is_delete: boolean;
  username: string;
  user_logo_url: string;
  create_time: string;
  update_time: string;
  is_team_source: boolean;
  export_time: string;
  xihe_task_progress_info: XiHeTaskProgress;
  is_star_personal: boolean;
  banned_status: IBannedStatus;
  banned_reason: string;
  appeal_status: IAppealStatus;
  appeal_reason: string;
  appeal_reject_reason: string;
}

export interface Opus {
  cover_oss_path: string;
  cover_url: string;
  detailed_scene: string;
  create_time: string;
  editor_last_position: any;
  home_status: number; // @deprecated
  id: number;
  is_deleted: boolean;
  is_new: boolean;
  is_star_personal: boolean;
  is_team_source: boolean;
  is_template: number;
  last_generate_record_data: any;
  map_type_tag_id: number;
  map_types: any[];
  message: string;
  model_type: COLLECTION_MAP;
  name: string;
  online_status: number;
  organization_id: string;
  preview_video: string;
  resolution: string;
  scene_status: number; // @deprecated
  score: number;
  secret_id: string;
  source: number;
  tag_ids: any;
  tag_ids_admin: any;
  tags: any[];
  tags_admin: any[];
  update_time: string;
  user_id: number;
  user_logo_url: string;
  username: string;
}
